<template>
  <div class="full-height">
    <div
      :class="{
        simpleButtons: rowButtons,
        crudButtons: !rowButtons,
        cleanLayout: cleanLayout,
      }"
      class="row container q-px-sm"
    >
      <div class="fit">
        <q-card class="q-px-sm card-crud">
          <q-card-section class="q-py-sm card-title">
            <div class="crud-title">
              <translate>SEARCH_RESULT</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-pb-lg card-table">
            <jt-data-table
              v-if="nmInterface && !slots.table"
              ref="jtDataTable"
              class="table-crud"
              :forms="forms"
              :buttons="datatable.buttons"
              :buttons-filter="filterButtons"
              :fields="datatable.columns"
              :extra-params="extraParam"
              :default-http-options="defaultHttpOptions"
              :nm-interface="nmInterface"
              singleselect
              :row-buttons="rowButtons"
              :selection-force="selectionForce"
              :column-edit="columnEdit || paintCell"
              :row-set="rowSet"
              :bottom-edit="bottomEdit"
              :multiselect="multiselect"
              :noneselect="noneselect"
              @selection="selection"
              @action-button="actionButton"
              @show-message="showMessage"
              @click-row="
                (row) => {
                  $emit('click-row', row)
                }
              "
            >
              <template v-for="(v, slot) in scopedSlotsComputer" v-slot:[slot]="props">
                <slot :name="slot" v-bind="props" />
              </template>
            </jt-data-table>

            <slot
              v-if="nmInterface"
              name="table"
              class="table-crud"
              :buttons="datatable.buttons"
              :buttons-filter="filterButtons"
              :fields="datatable.columns"
              :extra-params="extraParam"
              :default-http-options="defaultHttpOptions"
              :nm-interface="nmInterface"
              singleselect
              :row-buttons="rowButtons"
              :selection-force="selectionForce"
              :selection="selection"
              :action-button="actionButton"
              :show-message="showMessage"
              :column-edit="columnEdit"
              :row-set="rowSet"
              :bottom-edit="bottomEdit"
              :multiselect="multiselect"
              :noneselect="noneselect"
              :click-row="
                (row) => {
                  $emit('click-row', row)
                }
              "
            />
          </q-card-section>
        </q-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtCrud } from 'jtech-webcomps'

const { pageTable } = JtCrud

@Component({
  mixins: [pageTable],
  components: {
    JtDataTable
  },
  props: {
    name: String,
    page: String,
    params: { type: Object, required: true },
    datatable: { type: Object, required: true },
    forms: { type: Array, required: true },
    parent: Object,
    rowButtons: {
      required: false,
      type: Boolean,
      default: false
    },
    insideModal: {
      required: false,
      type: Boolean,
      default: false
    },
    cleanLayout: {
      required: false,
      type: Boolean,
      default: false
    },
    columnEdit: {
      type: Function
    },
    selectionForce: {
      required: false,
      type: Boolean,
      default: false
    },
    bottomEdit: {
      type: Function
    },
    rowSet: {
      type: Function
    },
    multiselect: {
      type: Boolean,
      default: false
    },
    noneselect: {
      type: Boolean,
      default: false
    }
  }
})
class TemplatePageTable extends Vue {
  refresh () {
    this.$refs?.jtDataTable?.refresh()
  }

  updated () {
    this.refresh()
  }

  selection (data) {
    this.$emit('selection', data)
  }

  actionButton (data, params) {
    this.$emit('action-button', data, params)
  }

  showMessage (data) {
    this.$emit('show-message', data)
  }

  paintCell (_cell) {
    switch (_cell.col.name) {
      case 'available':
        return this.paintStatusCell(_cell)
    }
  }

  paintStatusCell (_cell) {
    const isActive = _cell.col.value === this.$gettext('ACTIVE') || _cell.col.value === true
    const statusText = isActive ? this.$gettext('ACTIVE') : this.$gettext('INACTIVE')
    const dotColor = isActive ? '#00613B' : '#EE0000'
    const dotStyle = `background-color: ${dotColor}; width: 12px; height: 12px; border-radius: 50%; display: inline-block; vertical-align: middle;`

    return `
      <div style="display: flex; align-items: center; gap: 8px;">
        <span style="${dotStyle}"></span>
        ${statusText}
      </div>
    `
  }
}

export default TemplatePageTable
</script>
